import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { flatMap, first, map } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { GroupService } from '../group/group.service';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class FacilitiesDepartmentsResolve implements Resolve<any> {

  private departments = new ReplaySubject<any>(1);

  constructor(
    private gs: GroupService,
    private cms: ACResourceService
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.getGroup().pipe(
      first(),
      flatMap(group => {
        var path = `/facility/department-list`
        let params = {}
        return this.cms.request('GET', path, params).pipe(
          first(),
          map(data => {
            this.departments.next(data)
            return data
          })
        )
      })
    )
  }
}